function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.0743 12.9349L25.7959 12.9349",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9416 23.6097L25.7952 12.9889",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9417 2.26019L25.7953 12.9888",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.629 13.9056L33.6113 13.8985C33.419 13.8985 33.224 13.9172 33.0353 13.8913C32.4664 13.8117 31.9852 13.589 32.0004 12.92C32.0147 12.2509 32.4816 12.0237 33.0764 12.022C35.2159 12.0139 33.6864 12.0139 34.775 12.022C40.0387 12.0229 45.3041 12.03 50.5678 12.0237C52.244 12.0211 53.447 10.8333 53.4264 9.24746C53.4076 7.7511 52.2001 6.56957 50.6939 6.57404C49.1797 6.57851 47.9749 7.83965 48.0205 9.37716C48.0268 9.56856 48.0643 9.75907 48.0777 9.95048C48.1189 10.5345 47.8917 10.9504 47.2844 11.039C46.6744 11.1275 46.3148 10.7805 46.2138 10.2152C46.0313 9.20095 46.1127 8.20904 46.5876 7.26811C47.5956 5.27713 49.7458 4.29327 51.9077 4.84513C53.9872 5.37552 55.3753 7.29226 55.3011 9.52921C55.2313 11.6579 53.6902 13.4664 51.5105 13.7911C50.3809 13.9602 49.2154 13.9181 48.0661 13.9244C45.254 13.9414 42.4411 13.9298 39.629 13.9298V13.9056Z",
  fill: "#F0F0F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.5342 16.2115C42.128 16.2115 44.7227 16.2124 47.3165 16.2106C49.057 16.2106 50.5158 17.4405 50.6581 19.0629C50.836 21.1067 49.7386 22.3311 47.9229 22.6862C46.2083 23.0207 44.6377 21.9072 44.2871 20.1935C44.1807 19.6702 44.3676 19.2874 44.8703 19.1121C45.3711 18.9377 45.762 19.1264 46.0241 19.5781C46.084 19.681 46.1153 19.7999 46.1609 19.9099C46.4623 20.6317 46.999 20.9358 47.6841 20.774C48.4256 20.5978 48.8576 20.0262 48.786 19.3152C48.7172 18.6256 48.1653 18.1184 47.4051 18.1131C45.0992 18.0987 42.7934 18.1068 40.4876 18.1068C37.5351 18.1077 36.5398 18.0818 33.5882 18.0818C33.4433 18.0818 33.2984 18.0907 33.1562 18.0737C32.5971 18.0084 32.1902 17.7499 32.1481 17.1435C32.1133 16.6328 32.573 16.2196 33.2107 16.2115C34.7938 16.1936 34.4199 16.2303 36.003 16.2294C37.18 16.2285 38.3571 16.2285 39.5342 16.2285V16.2115Z",
  fill: "#F0F0F5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.1171 9.74877C34.5564 9.74877 34.9511 9.75565 33.3912 9.74581C32.6256 9.74133 32.1524 9.38625 32.1399 8.84691C32.1265 8.27001 32.6184 7.87557 33.4073 7.87379C36.4331 7.86931 37.5035 7.87764 40.5293 7.87317C41.3495 7.87138 41.9327 7.38661 42.0015 6.68896C42.0713 5.98773 41.6232 5.35806 40.93 5.18365C40.2574 5.0146 39.6465 5.37863 39.3263 6.1845C39.0991 6.75514 38.7441 7.06193 38.1144 6.875C37.5285 6.70058 37.3344 6.17377 37.5679 5.46002C37.9587 4.25971 39.1537 3.34204 40.4229 3.26601C41.7779 3.18551 43.0605 3.95561 43.6052 5.17918C44.5703 7.34725 43.0453 9.72551 40.6581 9.75145C39.1448 9.76845 37.6305 9.75503 36.1171 9.75503V9.74877Z",
  fill: "#F0F0F5"
});

function SvgWindW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 26,
    viewBox: "0 0 56 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindW);
export default __webpack_public_path__ + "static/media/wind-W.fb8e56d0.svg";
export { ForwardRef as ReactComponent };